import * as React from 'react';
import type { TextTone, TextWeight } from '../../lib/types';
import { Text, type TextVariant } from '../Text';

/**
 * Props for the Identifier component.
 */
export interface IdentifierProps extends React.ComponentPropsWithRef<'span'> {
  /**
   * Typography size, from the Text scale.
   * @default 'body-sm'
   */
  variant?: TextVariant;
  /**
   * Colour tone.
   * @default 'default'
   */
  tone?: TextTone;
  /**
   * Font weight.
   * @default 'normal'
   */
  weight?: TextWeight;
}

/**
 * Identifier shows a register id or code, such as a HER-id, an org number or
 * an HPR number, in monospace so each character is easy to compare. Unlike
 * `Code`, it has no chip background, so it sits flush in a table cell or a
 * line of text.
 */
export function Identifier({ variant = 'body-sm', tone = 'default', ...props }: IdentifierProps) {
  return <Text as="span" variant={variant} tone={tone} font="mono" {...props} />;
}
